import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2023重庆·铜梁文创产品设计大赛';
const baseUrl = '0310WCSJDS';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home/1`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home/:tabIndex',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;
